import { render } from "./chart-slot.vue?vue&type=template&id=0c12bd57&scoped=true"
const script = {}

import "./chart-slot.vue?vue&type=style&index=0&id=0c12bd57&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c12bd57"]])

export default __exports__